import { render, staticRenderFns } from "./loginCXWhite.vue?vue&type=template&id=199bcb5c"
import script from "./loginCXWhite.vue?vue&type=script&lang=js"
export * from "./loginCXWhite.vue?vue&type=script&lang=js"
import style0 from "./loginCXWhite.vue?vue&type=style&index=0&id=199bcb5c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports